<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e286">
<p class="tx8" id="d41151681"><b>For Samantha </b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap5_howtorob_9781569477113_epub_part5.vue?36ea231a